// AUTO-GENERATED by scripts/sync-locale-twins.mjs; do not edit.
// Source: a scan of literal src/app/hi/** page.tsx routes.
//
// HI_LITERAL_PATHS: every literal Hindi route (slug form, no /hi/ prefix) —
// lets the LanguageToggle switch to the EXACT nested twin when it exists.
// HI_TOP_LEVEL_SLUGS: Hindi slugs with a top-level page (hub fallback target).
// The en<->hi slug ALIASES stay hand-authored in locales.ts (they are naming
// decisions, not derivable); everything else about "does a twin exist" is
// derived from the filesystem so it can never drift again.

export const HI_DYNAMIC_PATH_PATTERNS: readonly RegExp[] = [
  "^calendar/festival/[^/]+$",
  "^gemstones/[^/]+$",
  "^lal-kitab-remedies/[^/]+$",
  "^mantras/[^/]+$",
  "^rashifal/[^/]+$",
  "^vastu-shastra/[^/]+$",
].map((pattern) => new RegExp(pattern));

export const HI_LITERAL_PATHS: ReadonlySet<string> = new Set([
  "aaj-ka-rashifal",
  "amavasya",
  "ascendant-calculator",
  "ashtakvarga",
  "astrologers",
  "baby-names",
  "bhagyank-calculator",
  "birth-time-rectification",
  "calendar/festival",
  "career-ke-liye-jyotish",
  "career-report",
  "char-dasha",
  "choghadiya",
  "choghadiya/tomorrow",
  "compatibility",
  "dasamsa",
  "dasha-calculator",
  "dosha-remedy-plan",
  "dwadasamsa",
  "ekadashi",
  "free-kundali",
  "gemstones",
  "graha",
  "graha/jupiter/in-10-house",
  "graha/jupiter/in-5-house",
  "graha/jupiter/in-kark",
  "graha/jupiter/in-mithun",
  "graha/ketu/in-10-house",
  "graha/ketu/in-12-house",
  "graha/ketu/in-2-house",
  "gun-milan",
  "kaal-sarp-dosha",
  "kp-astrology",
  "kundli-matching",
  "lal-kitab-kundli",
  "lal-kitab-remedies",
  "mahadasha",
  "mahadasha/jupiter/jupiter-antardasha",
  "mahadasha/ketu/mars-antardasha",
  "mahadasha/ketu/mercury-antardasha",
  "mahadasha/ketu/moon-antardasha",
  "mahadasha/ketu/sun-antardasha",
  "mahadasha/ketu/venus-antardasha",
  "mahadasha/mars/sun-antardasha",
  "mahadasha/mars/venus-antardasha",
  "mahadasha/mercury/jupiter-antardasha",
  "mahadasha/mercury/ketu-antardasha",
  "mahadasha/mercury/mars-antardasha",
  "mahadasha/mercury/moon-antardasha",
  "mahadasha/mercury/rahu-antardasha",
  "mahadasha/mercury/saturn-antardasha",
  "mahadasha/moon/jupiter-antardasha",
  "mahadasha/moon/moon-antardasha",
  "mahadasha/moon/rahu-antardasha",
  "mahadasha/moon/saturn-antardasha",
  "mahadasha/moon/sun-antardasha",
  "mahadasha/moon/venus-antardasha",
  "mahadasha/rahu/ketu-antardasha",
  "mahadasha/rahu/mercury-antardasha",
  "mahadasha/rahu/rahu-antardasha",
  "mahadasha/saturn/mars-antardasha",
  "mahadasha/saturn/mercury-antardasha",
  "mahadasha/saturn/rahu-antardasha",
  "mahadasha/sun/ketu-antardasha",
  "mahadasha/sun/mercury-antardasha",
  "mahadasha/sun/rahu-antardasha",
  "mahadasha/sun/sun-antardasha",
  "mahadasha/venus/mercury-antardasha",
  "mahadasha/venus/moon-antardasha",
  "mahadasha/venus/saturn-antardasha",
  "mangal-dosha-calculator",
  "manglik-calculator",
  "mantras",
  "marriage-report",
  "masik-shivratri",
  "mercury-retrograde",
  "muft-jyotish-chat",
  "muhurat",
  "mulank-calculator",
  "nadi-astrology",
  "nadi-dosh",
  "nakshatra",
  "nakshatra-calculator",
  "name-numerology",
  "navamsa-chart",
  "numerology",
  "panchang",
  "panchang/tomorrow",
  "pandits",
  "pitra-dosha",
  "pradosh",
  "prashna-kundali",
  "privacy",
  "purnima",
  "rahu-kaal",
  "rahu-kaal/tomorrow",
  "rashi",
  "rashi-calculator",
  "remedies",
  "sade-sati",
  "sankashti-chaturthi",
  "sankranti",
  "saptamsa",
  "saturn-transit",
  "shaadi-ke-liye-jyotish",
  "shadbala",
  "shashtiamsa",
  "shubh-muhurat",
  "shubh-muhurat/today",
  "tara-balam",
  "tithi-today",
  "transits",
  "trimsamsa",
  "upay",
  "vastu-shastra",
  "venus-transit",
  "vrat-calendar",
  "widgets",
  "yoga",
  "yoga/adhi-yoga",
  "yoga/anapha",
  "yoga/chandra-mangal",
  "yoga/dhana-yoga",
  "yoga/kahala-yoga",
  "yoga/malavya",
  "yoga/neecha-bhanga-raja-yoga",
  "yoga/papa-kartari",
  "yoga/raja-yoga",
  "yoga/sankha-yoga",
  "yoga/shakata",
  "yogini-dasha",
]);

export const HI_TOP_LEVEL_SLUGS: ReadonlySet<string> = new Set([
  "aaj-ka-rashifal",
  "amavasya",
  "ascendant-calculator",
  "ashtakvarga",
  "astrologers",
  "baby-names",
  "bhagyank-calculator",
  "birth-time-rectification",
  "career-ke-liye-jyotish",
  "career-report",
  "char-dasha",
  "choghadiya",
  "compatibility",
  "dasamsa",
  "dasha-calculator",
  "dosha-remedy-plan",
  "dwadasamsa",
  "ekadashi",
  "free-kundali",
  "gemstones",
  "graha",
  "gun-milan",
  "kaal-sarp-dosha",
  "kp-astrology",
  "kundli-matching",
  "lal-kitab-kundli",
  "lal-kitab-remedies",
  "mahadasha",
  "mangal-dosha-calculator",
  "manglik-calculator",
  "mantras",
  "marriage-report",
  "masik-shivratri",
  "mercury-retrograde",
  "muft-jyotish-chat",
  "muhurat",
  "mulank-calculator",
  "nadi-astrology",
  "nadi-dosh",
  "nakshatra",
  "nakshatra-calculator",
  "name-numerology",
  "navamsa-chart",
  "numerology",
  "panchang",
  "pandits",
  "pitra-dosha",
  "pradosh",
  "prashna-kundali",
  "privacy",
  "purnima",
  "rahu-kaal",
  "rashi",
  "rashi-calculator",
  "remedies",
  "sade-sati",
  "sankashti-chaturthi",
  "sankranti",
  "saptamsa",
  "saturn-transit",
  "shaadi-ke-liye-jyotish",
  "shadbala",
  "shashtiamsa",
  "shubh-muhurat",
  "tara-balam",
  "tithi-today",
  "transits",
  "trimsamsa",
  "upay",
  "vastu-shastra",
  "venus-transit",
  "vrat-calendar",
  "widgets",
  "yoga",
  "yogini-dasha",
]);
